module.exports = __webpack_public_path__ + "media/salto.8162c97d.mp4";